module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-title"
  }, [_c('span', [_vm._v("OFF TO THE RACES")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "images/OffToTheRaces.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_c('b', [_vm._v("Across")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("1.  Gardner creation")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("6.  Toss")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("11. Sixth sense; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("14. Derby winner of 1905")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("15. Spanish queen")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("16. My _____")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("17. Cut-ups")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("18. Suggest")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("19. SM, MED, _____")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("20. Police radio call; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("21. 1973 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("24. Upper NYC thoroughfare")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("25. Sizzle")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("26. Black Sea port")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("27. Attach")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("30. Hair raiser?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("31. Big name in insurance")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("33. Int. commerce grp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("35. A Winkler")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("39. Milking aid")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("40. Manhattan campus; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("41. Harlot of Jericho")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("42. D.C. naval facility")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("43. Poetic evening")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("44. Kansas City university")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("45. U2 or ELO")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("47. Roofer")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("49. San Fernando Valley town")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("52. Pats’ old org.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("53. Grass court org.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("56. 1977 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("59. Tire need")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("60. Stooge")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("61. Easter in Italy, e.g.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("62. Certain manual")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("64. Ike’s WWII turf")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("65. Actor, Davis")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("66. 1935 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("67. “Ask _____ …”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("68. Scratches")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("69. Songster, Leo")]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_c('b', [_vm._v("Down")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("1.  Certain parrot")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("2.  Wide open")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("3.  1919 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("4.  _____ Rosebud, 1914 Derby winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("5.  Stack role")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("6.  Adjective for 21-Across, et al.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("7.  A Winkler")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("8.  Overrun with")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("9.  _____ many; over the top")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("10. 1937 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("11. Winning jockey, 1931 Preakness")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("12. Long tales")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("13. Michelangelo masterpiece")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("22. Little lizard")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("23. Try it again")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("28. Circling")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("29. 1930 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("30. 1943 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("31. Tempe campus; abbr.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("32. UFO crew")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("34. Lanyard")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("36. 1941 winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("37. Baron tack-on")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("38. Hoopster’s org.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("46. Even so")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("48. Chill")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("49. City on the Ruhr")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("50. “Cool!”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("51. 1949 Preakness winner")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("52. Spite in Spinazzola")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("54. Church offering")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("55. Like the crowd at the track")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("57. Old gas sign")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("58. “_____ Afraid of Virginia Woolf?”")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent2"
  }, [_vm._v("63. Tumor; suffix")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("To download a PDF of this puzzle, please visit "), _c('a', {
    attrs: {
      "href": "http://www.openroadmedia.com/nero-blanc-crosswords",
      "target": "_blank"
    }
  }, [_vm._v("openroadmedia.com/nero-blanc-crosswords")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81bd38f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter003.vue
// module id = 81
// module chunks = 0